import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { UserAffiliationMappingCreateRequestDTO, UserAffiliationMappingDeleteRequestDTO, UserAffiliationMappingDTO, UserAffiliationMappingList, UserAffiliationMappingReadByBusinessIdRequestDTO, UserAffiliationMappingReadByIdRequestDTO, UserAffiliationMappingReadByUserIdRequestDTO, UserAffiliationMappingUpdateRequestDTO } from "./userAffiliationMapping.interface";
import { Observable } from "rxjs";
import { UserAffiliationMapping_Create, UserAffiliationMapping_Delete, UserAffiliationMapping_ReadAll, UserAffiliationMapping_ReadByBusinessId, UserAffiliationMapping_ReadById, UserAffiliationMapping_ReadByUserId, UserAffiliationMapping_Update } from "src/app/GlobalVariable";

@Injectable ({
    providedIn: 'root'
})

export class UserAffiliationMappingService {
    private http = inject(HttpClient);

    UserAffiliationMapping_Create(data: UserAffiliationMappingCreateRequestDTO): Observable<UserAffiliationMappingDTO> {
        return this.http.post<UserAffiliationMappingDTO>(UserAffiliationMapping_Create, data);
    }

    UserAffiliationMapping_Update(data: UserAffiliationMappingUpdateRequestDTO): Observable<UserAffiliationMappingDTO> {
        return this.http.post<UserAffiliationMappingDTO>(UserAffiliationMapping_Update, data);
    }

    UserAffiliationMapping_Delete(data: UserAffiliationMappingDeleteRequestDTO): Observable<void> {
        return this.http.post<void>(UserAffiliationMapping_Delete, data);
    }

    UserAffiliationMapping_ReadAll(): Observable<UserAffiliationMappingList> {
        return this.http.get<UserAffiliationMappingList>(UserAffiliationMapping_ReadAll);
    }

    UserAffiliationMapping_ReadById(data: UserAffiliationMappingReadByIdRequestDTO): Observable<UserAffiliationMappingDTO> {
        return this.http.post<UserAffiliationMappingDTO>(UserAffiliationMapping_ReadById, data);
    }

    UserAfiliationMapping_ReadByUserId(data: UserAffiliationMappingReadByUserIdRequestDTO): Observable<UserAffiliationMappingDTO> {
        return this.http.post<UserAffiliationMappingDTO>(UserAffiliationMapping_ReadByUserId, data);
    }

    UserAffiliationMapping_ReadByBusinessId(data: UserAffiliationMappingReadByBusinessIdRequestDTO): Observable<UserAffiliationMappingList> {
        return this.http.post<UserAffiliationMappingList>(UserAffiliationMapping_ReadByBusinessId, data);
    }
}